import { useMemo } from "react";
import { Query } from "../generated/nest-graphql";

export type PartInfo = {
  partNumber: string | null;
  store: string | null;
  partName: string | null;
};

export const useAllParts = (invoiceData: Query["getInvoice"] | undefined): PartInfo[] => {
  return useMemo(() => {
    if (!invoiceData?.services) return [];
    const parts: PartInfo[] = [];
    invoiceData.services?.forEach((service) => {
      service?.items?.forEach((item) => {
        if (item?.category === "Part" && item?.jobItem) {
          const partNumber = item.jobItem.partNumber || null;
          const store = item.jobItem.partOrder?.store?.name || null;
          let partName = null;

          if (item.jobItem.partOrder?.items) {
            partName = item.jobItem.partOrder.items?.find((item) => item?.partNumber === partNumber)?.name || null;
          }

          if (partNumber || store || partName) {
            parts.push({ partNumber, store, partName });
          }
        }
      });
    });
    return parts;
  }, [invoiceData?.services]);
};
